import Vue from 'vue'
import Router from 'vue-router'
//公共板块
import routerIndex from '@/components/routerIndex'
import home from '@/components/common/home'

Vue.use(Router)


export default new Router({
	routes: [{
		path: '/',
		name: 'home',
		component: home
	}, {
		path: '/home',
		component: home
	}, {
		path: '*',
		redirect: '/home',
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js